import React, { FC } from "react";
import { FormattedDate } from "react-intl";

import { useTime } from "../../../hooks";
import Digital from "./Digital";
import { Props, defaultData } from "./types";
import "./Time.sass";
import { utcToZonedTime } from "date-fns-tz";

const Time: FC<Props> = ({ data = defaultData }) => {
  const {
    hour12,
    showDate,
    showMinutes,
    showSeconds,
    timeZone,
    showDayPeriod = true,
    showTime,
  } = data;
  let time = useTime(timeZone ? "absolute" : "zoned");

  if (timeZone) {
    time = utcToZonedTime(time, timeZone);
  }

  return (
    <div className="Time">
      {
        showTime && <Digital
          time={time}
          hour12={hour12}
          showMinutes={showMinutes}
          showSeconds={showSeconds}
          showDayPeriod={showDayPeriod}
        />
      }
      {showDate && (
        <>
          {showTime && <hr style={{ margin: '2px 0' }}/>}
          <FormattedDate
            value={time}
            day="numeric"
            month="long"
            weekday="long"
          />
        </>
      )}
    </div>
  );
};

export default Time;
